var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2456_12496)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.12695,
    y: 5,
    width: 7,
    height: 10,
    rx: 0.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.127,
    y: 2,
    width: 11,
    height: 16,
    rx: 0.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.12695,
    y: 1,
    width: 4,
    height: 4,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.83529,
    y: 0.708333,
    width: 6.58333,
    height: 0.416667,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.416667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.881836,
    y: 12.0147,
    width: 4,
    height: 3.25417,
    transform: "rotate(-89.6633 0.881836 12.0147)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.473633,
    y: 13.4123,
    width: 6.8,
    height: 0.509029,
    transform: "rotate(-89.6633 0.473633 13.4123)",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.627,
    y: 6.5,
    width: 7,
    height: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.627,
    y: 6.5,
    width: 7,
    height: 1,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.727,
    y: 9.6,
    width: 6.8,
    height: 0.8,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.727,
    y: 12.6,
    width: 6.8,
    height: 0.8,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2456_12496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 24,
    fill: "white",
    transform: "translate(1.573047 0.9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotors);
export default __webpack_public_path__ + "static/media/Motors.a5ec67941e7e384bcba2c847d59d42ad.svg";
export { ForwardRef as ReactComponent };